import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/auth/me");
        setUser(r.data);
        // Sliding refresh: roll the long-lived token forward on each open so the owner stays signed in.
        api.post("/auth/refresh").then((rr) => { if (rr.data?.token) localStorage.setItem("et_token", rr.data.token); }).catch(() => {});
      } catch {
        // Access token missing/expired — try the long-lived refresh cookie, then retry.
        try {
          const rr = await api.post("/auth/refresh");
          if (rr.data?.token) localStorage.setItem("et_token", rr.data.token);
          const r2 = await api.get("/auth/me");
          setUser(r2.data);
        } catch {
          setUser(false);
        }
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("et_token", data.token);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("et_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
